export enum AzureErrors {
    RESET_PASSWORD = 'AADB2C90118',
    CANCELED_RESET_PASSWORD = 'AADB2C90091'
}